var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "mb-4", attrs: { id: "knowledge-base-search" } },
      [
        _c("h2", { staticClass: "mb-1" }, [_vm._v("Onboarding Checklist")]),
        _c(
          "b-list-group",
          _vm._l(_vm.checklistItems, function (item, index) {
            return _c(
              "b-list-group-item",
              {
                key: index,
                staticClass:
                  "d-flex align-items-center justify-content-between",
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "span",
                    {
                      class: {
                        "text-muted text-decoration-line-through": item.checked,
                      },
                    },
                    [
                      _c("strong", [_vm._v(_vm._s(item.title))]),
                      _vm._v(" " + _vm._s(item.text) + " "),
                    ]
                  ),
                ]),
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "primary" },
                    on: {
                      click: function ($event) {
                        item.url
                          ? _vm.openUrl(item.url)
                          : _vm.goToTab(item.activeTab)
                      },
                    },
                  },
                  [_vm._v("Go")]
                ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }